// extracted by mini-css-extract-plugin
export default {"extLogin":"ExternalLogin_extLogin__Xazoq"};